import * as actionTypes from './actionTypes';
import { DeepReadonly } from '../../declarations';
import { ILoadingRequest, Request } from './';
import { RequestsActions } from './actionTypeMap';

interface IRequestsState {
  requests: { [requestId: string]: Request<unknown> };
}

export type RequestsState = DeepReadonly<IRequestsState>;

export const initialState: RequestsState = {
  requests: {},
};

export default function reducer(
  state: RequestsState = initialState,
  action: RequestsActions,
): RequestsState {
  switch (action.type) {
    case actionTypes.BEGIN_REQUEST:
      return {
        ...state,
        requests: {
          ...state.requests,
          [action.payload.requestId]: { state: 'loading', started: Number(new Date()) },
        },
      };
    case actionTypes.PUT_REQUEST_SUCCESS:
      return {
        ...state,
        requests: {
          ...state.requests,
          [action.payload.requestId]: {
            ...(state.requests[action.payload.requestId] as ILoadingRequest),
            ended: Number(new Date()),
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            response: action.payload.response as any,
            state: 'success',
          },
        },
      };
    case actionTypes.PUT_REQUEST_ERROR:
      return {
        ...state,
        requests: {
          ...state.requests,
          [action.payload.requestId]: {
            ...state.requests[action.payload.requestId],
            ended: Number(new Date()),
            error: action.payload.error,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            response: action.payload.response as any,
            state: 'error',
          },
        },
      };
    default:
      return state;
  }
}
